
import Button from '../../../components/base/Button';

export default function CTASection() {
  return (
    <section className="py-24 bg-gradient-to-br from-white via-blue-50 to-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div 
          className="rounded-3xl overflow-hidden shadow-2xl bg-cover bg-center relative"
          style={{
            backgroundImage: `linear-gradient(135deg, rgba(15, 23, 42, 0.9), rgba(30, 58, 138, 0.85)), url('https://public.readdy.ai/ai/img_res/71e0b2f33a3d728eaaf53b180f0fcd7c.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/50 to-blue-900/50"></div>
          
          <div className="relative z-10 px-8 py-16 md:px-16 md:py-24">
            <div className="max-w-3xl mx-auto text-center">
              <div className="inline-flex items-center px-6 py-3 bg-white/10 backdrop-blur-sm text-white rounded-full text-sm font-semibold mb-8 shadow-lg border border-white/20">
                <i className="ri-rocket-line mr-2 text-emerald-400"></i>
                Ready to Get Started?
              </div>
              
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Let's Fund Your Next Investment Property
              </h2>
              
              <p className="text-xl text-white/90 mb-12 leading-relaxed">
                With $2.1M worth of properties funded and proven expertise in DSCR financing, we're ready to help you expand your real estate portfolio. Whether it's your first rental or you're considering expansion, contact us today to discuss your investment goals.
              </p>

              <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
                <Button 
                  size="lg" 
                  className="bg-gradient-to-r from-emerald-500 to-blue-500 hover:from-emerald-600 hover:to-blue-600 text-white font-bold shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer text-lg px-8 py-4"
                  onClick={() => window.REACT_APP_NAVIGATE('/#contact')}
                >
                  <i className="ri-mail-line mr-2"></i>
                  Contact Us Today
                </Button>
                <Button 
                  size="lg" 
                  variant="outline"
                  className="border-2 border-white text-white hover:bg-white hover:text-slate-900 backdrop-blur-sm bg-white/10 font-bold shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer text-lg px-8 py-4"
                  onClick={() => {
                    const calculator = document.getElementById('dscr-calculator');
                    if (calculator) {
                      calculator.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  <i className="ri-calculator-line mr-2"></i>
                  DSCR Calculator
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
